import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { MapCircleIcon } from "../components/maps";
import { Typography, Box } from "@material-ui/core";
import { useTheme } from "@material-ui/styles";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexDirection: "rows",
    padding: theme.spacing(1)
  }
}));

export default function RmsdList({ maps }) {
  const classes = useStyles();

  const elements = maps.map(row => {
    return (
      <Box display="flex" flexDirection="row" alignItems="center" px={0.5}>
        <Box component="span" py={0.25}>
          {" "}
          <MapCircleIcon {...row.options} size="small" />
        </Box>
        <Box component="span" ml={0.25}>
          {row.options.rmsd.toFixed(2)}{" "}
        </Box>
      </Box>
    );
  });

  return (
    <Box
      display="flex"
      alignItems="center"
      flexDirection="row"
      alignItems="center"
      p={0.5}
    >
      {elements.length ? <span> Maps' rmsd: </span> : <span>&nbsp;</span>}
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        flexWrap="wrap"
      >
        {elements}
      </Box>
    </Box>
  );
}
